export default __webpack_public_path__ + "static/media/key-function.90acafdb.svg";